var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8163 8.29945C17.7185 6.89428 17.2892 5.53227 16.5637 4.32493C15.8382 3.1176 14.837 2.09927 13.6422 1.35333C12.4473 0.607386 11.0928 0.155048 9.6895 0.0333507C8.2862 -0.0883469 6.87403 0.124057 5.56862 0.653169C4.26321 1.18228 3.10168 2.01306 2.17914 3.07747C1.2566 4.14188 0.599284 5.40967 0.261013 6.77701C-0.0772591 8.14435 -0.0868662 9.57237 0.232978 10.9441C0.552822 12.3159 1.19302 13.5924 2.10116 14.6692L5.85126 11.5062C5.44264 11.0218 5.15458 10.4474 5.01066 9.83017C4.86675 9.21294 4.87107 8.5704 5.02328 7.95516C5.17548 7.33992 5.47125 6.76948 5.88634 6.29055C6.30144 5.81161 6.82407 5.4378 7.41145 5.19973C7.99882 4.96165 8.63423 4.86608 9.26564 4.92084C9.89706 4.9756 10.5065 5.17913 11.0441 5.51477C11.5818 5.8504 12.0322 6.3086 12.3587 6.85185C12.6851 7.39509 12.8783 8.00793 12.9223 8.64019L17.8163 8.29945Z",
    fill: "#3A4D87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89169 14.3597C2.7277 15.4982 3.82218 16.422 5.08504 17.0548L7.2827 12.6692C6.71441 12.3845 6.2219 11.9688 5.84569 11.4564L1.89169 14.3597Z",
    fill: "#D4F7A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2255 15.2255C16.8016 13.6495 17.7304 11.5404 17.8291 9.31372C17.9278 7.08702 17.1891 4.90407 15.7586 3.19479L11.9968 6.34306C12.6405 7.11224 12.9729 8.09456 12.9285 9.09658C12.8841 10.0986 12.4661 11.0477 11.7569 11.7569L15.2255 15.2255Z",
    fill: "#FFD600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91892 17.8378C10.3608 17.8378 11.7812 17.4882 13.0584 16.819C14.3357 16.1498 15.4316 15.1809 16.2522 13.9953L12.2189 11.2033C11.8496 11.7368 11.3564 12.1728 10.7817 12.474C10.207 12.7751 9.56778 12.9324 8.91892 12.9324L8.91892 17.8378Z",
    fill: "#EF9BFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97782 16.9198C6.22929 17.5363 7.60792 17.8506 9.00291 17.8374L8.95672 12.9323C8.32897 12.9382 7.70859 12.7967 7.14543 12.5193L4.97782 16.9198Z",
    fill: "#F7B0A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonutIcon);
export default __webpack_public_path__ + "static/media/donutIcon.77861cce8310479d9cb6a7244433eeec.svg";
export { ForwardRef as ReactComponent };